import type { HelpFile } from '../../types/help'
import { ErrorLogDetailTestIds } from '../../../testids/ErrorLogDetailTestIds'

export const errorLogDetailHelp: HelpFile = {
  docPage: '/docs/admin/error-log',
  texts: {
    [ErrorLogDetailTestIds.errorLogDetailPage]: 'Details zu einem einzelnen Fehler — wer ihn ausgelöst hat, wann, mit welcher Anfrage und der vollständige Stack-Trace.',
    [ErrorLogDetailTestIds.patternDetailPage]: 'Alle Vorkommen desselben Fehlermusters zusammengefasst — zeigt Häufigkeit und betroffene Nutzer. Volltextsuche durchsucht nur die Meldung (mindestens 3 Zeichen).',
    [ErrorLogDetailTestIds.patternInfo]: null,
    [ErrorLogDetailTestIds.patternStacktrace]: 'Gemeinsamer Stack-Trace aller Vorkommen dieses Musters.',
    [ErrorLogDetailTestIds.cardTitleStackTrace]: null,
    [ErrorLogDetailTestIds.stacktracePre]: 'Vollständiger Stack-Trace — zum Kopieren für Tickets oder die Weitergabe an die Entwicklung.',
    [ErrorLogDetailTestIds.cardTitleRequestContext]: null,
    [ErrorLogDetailTestIds.requestContextCard]: 'Anfrage, die den Fehler ausgelöst hat — HTTP-Methode, Pfad und Header zum Zeitpunkt der Erfassung.',
    [ErrorLogDetailTestIds.requestSourceBadge]: 'Herkunft der Anfrage: Browser-Sitzung, Hintergrund-Job oder API-Client.',
    [ErrorLogDetailTestIds.btnToggleHeaders]: null,
    [ErrorLogDetailTestIds.headersContent]: 'Header so, wie der Server sie empfangen hat — sensible Werte (Authorization, Cookies) sind geschwärzt.',
    [ErrorLogDetailTestIds.cardTitleOccurrenceContext]: null,
    [ErrorLogDetailTestIds.occurrenceContext]: 'Kontext dieses Vorkommens — angemeldeter Nutzer, Sitzung und ggf. Testlauf.',
    [ErrorLogDetailTestIds.authUsernameValue]: 'Authentifizierter Nutzer beim Auftreten des Fehlers — leer bei anonymen Anfragen.',
    [ErrorLogDetailTestIds.actionIdValue]: 'Interne Aktions-ID — hilfreich beim Abgleich mit Audit-Log-Einträgen.',
    [ErrorLogDetailTestIds.sessionIdValue]: null,
    [ErrorLogDetailTestIds.sessionIdLink]: 'Sitzung im Request-Inspector öffnen, um alle Spans rund um den Fehler zu sehen.',
    [ErrorLogDetailTestIds.userAgentValue]: null,
    [ErrorLogDetailTestIds.e2eRunIdValue]: 'E2E-Testlauf-ID — nur vorhanden, wenn der Fehler aus einem automatisierten Playwright-Lauf stammt.',
    [ErrorLogDetailTestIds.e2eTestClassValue]: null,
    [ErrorLogDetailTestIds.e2eTestMethodValue]: null,
    [ErrorLogDetailTestIds.cardTitleOccurrences]: null,
    [ErrorLogDetailTestIds.occurrencesCard]: 'Alle einzelnen Vorkommen dieses Fehlermusters, neueste zuerst.',
    [ErrorLogDetailTestIds.occurrencesTable]: null,
    [ErrorLogDetailTestIds.colTime]: null,
    [ErrorLogDetailTestIds.colContext]: 'Anfrage- oder Job-Kontext dieses Vorkommens.',
    [ErrorLogDetailTestIds.colSourceEntity]: 'Entität (Partei, System, Anfrage), auf die die fehlgeschlagene Operation gewirkt hat.',
    [ErrorLogDetailTestIds.btnCopyCorrelationId]: 'Korrelations-ID kopieren — für Tickets oder den Austausch mit der Entwicklung.',
    [ErrorLogDetailTestIds.btnCopyTrace]: null,
  },
}
